<template>
  <div class="index container">
    <div class="card" v-for="thanphod in thanphods" :key="thanphod.id">
      <div class="card-content">
        <i class="material-icons delete" @click="deleteThanphod(thanphod.id)">delete</i>
        <h2 class="indigo-text">{{ thanphod.title }}</h2>
        <ul class="ingredients">
          <li v-for="(ing, index) in thanphod.ingredients" :key="index">
            <span class="chip">{{ ing }}</span>
          </li>
        </ul>
      </div>
      <span class="btn-floating btn-large halfway-fab pink">
        <router-link :to="{ name: 'EditThanphod', params: {thanphod_slug: thanphod.slug} }">
          <i class="material-icons edit">edit</i>
        </router-link>
      </span>
    </div>
  </div>
</template>

<script>
import db from '@/firebase/init'

export default {
  name: 'Index',
  data(){
    return{
      thanphods:[]
    }
  },
  methods:{
    deleteThanphod(id){
      // delete doc from firestore
      db.collection('thanphods').doc(id).delete()
      .then(() => {
        this.thanphods = this.thanphods.filter(thanphod => {
        return thanphod.id != id
        })
      }) 
    }
  },
  created(){
    // fetch data from firestore
    db.collection('thanphods').get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        let thanphod = doc.data()
        thanphod.id = doc.id
        this.thanphods.push(thanphod)
      })
    })
  }
}
</script>

<style>
 div{
   font-family: phetsarath ot;
 }
 .index{
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   grid-gap: 30px;
   margin-top: 60px;
 }
 .index h2{
   font-size: 1.8em;
   text-align: center;
   margin-top: 0;
 }
 .index .ingredients{
   margin: 30px auto;
 }
 .index .ingredients li{
   display: inline-block;
 }
 .index .delete{
   position: absolute;
   top: 4px;
   right: 4px;
   cursor: pointer;
   color: #aaa;
   font-size: 1.4em;
 }
</style>





// WEBPACK FOOTER //
// src/components/Index.vue